import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, IconButton, Fade, Box } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CloseIcon from "@mui/icons-material/Close";

interface ConfirmationModalProps {
  isVisible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  message: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ isVisible, onConfirm, onCancel, message }) => {
  return (
    <Dialog
      open={isVisible}
      onClose={onCancel}
      TransitionComponent={Fade}
      maxWidth="xs"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          minHeight: "200px",  // Ensures balanced size
          borderRadius: "16px", // Rounded corners
          display: "flex",
          flexDirection: "column"
        }
      }}
    >
      {/* Modal Header */}
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#ff9800",
          color: "white",
          padding: "8px 16px", // Reduced padding
          borderTopLeftRadius: "12px",
          borderTopRightRadius: "12px"
        }}
      >
        <Box display="flex" alignItems="center">
          <WarningAmberIcon sx={{ marginRight: 0.5, fontSize: 22 }} /> {/* Smaller Icon */}
          <Typography variant="subtitle1" fontWeight="bold">Confirm Action</Typography> {/* Smaller Text */}
        </Box>
        <IconButton onClick={onCancel} sx={{ color: "white", padding: "4px" }}> {/* Smaller Close Button */}
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      {/* Modal Body (Vertically Centered) */}
      <DialogContent
        sx={{
          padding: 3,
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexGrow: 1
        }}
      >
        <Box textAlign="center">
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#333", display: "block" }}
            mt={2}
          >
            Please confirm !
          </Typography>

          <Typography
            variant="subtitle2"
            sx={{ fontSize: "1rem", color: "#555", display: "block" }}
            mt={1}
          >
            {message}
          </Typography>
        </Box>

      </DialogContent>

      {/* Modal Footer - Buttons */}
      <DialogActions sx={{ justifyContent: "center", paddingBottom: 2 }}>
        <Button variant="contained" color="error" onClick={onConfirm}>
          Yes, Proceed
        </Button>
        <Button variant="outlined" color="secondary" onClick={onCancel}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
